<template>
  <div>
    <div class="project border border-info rounded p-2">
      <div class="checkProject d-flex justify-content-between align-items-baseline mb-2">
        <b-row>
          <b-col class="sm-12">
            <div class="d-flex">
              <b-form-checkbox class="ml-2" v-model="project.checkProject">
                <p class="btn p-0 m-0 text-info">Project With CO Mapping</p>
              </b-form-checkbox>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="sm-6">
            <div v-if="project.checkProject">
              <label for="projectScore">Score:</label>
              <b-form-input
                id="projectScore"
                v-model="project.projectScore"
                placeholder="Enter Score"
                :class="{
                  'form-group-error': $v.project.projectScore.$error,
                }"
              ></b-form-input>
              <span
                class="input-error-message"
                v-if="
                  !$v.project.projectScore.required &&
                  $v.project.projectScore.$dirty
                "
              >
                Score is mandatory!
              </span>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-collapse id="projectConfig" v-model="project.checkProject" class="mt-2">
        <div class="selectProjectType mb-2">
          <span class="text-dark font-weight-bolder">Choose Project Methods:</span>
        </div>

        <table class="table table-bordered table-striped">
          <thead class="thead-dark">
            <tr>
              <th></th>
              <th>Project Method</th>
              <th v-if="!activity_simple_calculation">Percent Weightage</th>
            </tr>
          </thead>

          <tbody>
            <tr v-if="projectMethods.length === 0">
              <td colspan="100" class="text-danger text-center align-middle">
                No Project Methods Found!
              </td>
            </tr>

            <tr v-for="(method, index) in projectMethods" :key="index">
              <td class="align-middle">
                <b-form-checkbox
                  size="sm"
                  v-model="projectConfigStructure[method.id].checkbox"
                ></b-form-checkbox>
              </td>

              <td class="align-middle">{{ method.name }}</td>

              <td
                v-if="!activity_simple_calculation"
                class="text-center align-middle"
              >
                <b-form-input
                  v-if="projectConfigStructure[method.id].checkbox"
                  placeholder="Enter Percentage"
                  v-model="projectConfigStructure[method.id].input"
                  @blur="$v.projectConfigStructure.$each.$touch()"
                ></b-form-input>

                <div
                  v-if="
                    projectConfigStructure[method.id].checkbox &&
                    $v.projectConfigStructure.$each[method.id].input.$error
                  "
                  class="text-danger"
                >
                  <span
                    v-if="!$v.projectConfigStructure.$each[method.id].input.required"
                  >
                    This field is required.
                  </span>
                  <span
                    v-if="!$v.projectConfigStructure.$each[method.id].input.numeric"
                  >
                    Value must be numeric.
                  </span>
                  <span
                    v-if="!$v.projectConfigStructure.$each[method.id].input.customValidation"
                  >
                    All inputs must either be the same or sum up to 100.
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { requiredIf, numeric } from "vuelidate/lib/validators";
import axios from "axios";

export default {
  props: ["saved_configs", "courseReport", "activity_simple_calculation"],

  async created() {
    await this.fetchProjectMethods();

    let savedProjectConfig = this.saved_configs.project_with_co_configs;
    if (savedProjectConfig.enable) {
      this.project = {
        checkProject: savedProjectConfig.enable,
        projectScore: savedProjectConfig.score,
        projectBestScore: savedProjectConfig.best_of_scores,
      };

      let selectedMethods = savedProjectConfig.resourses.method;
      for (const key in selectedMethods) {
        if (key in this.projectConfigStructure) {
          this.projectConfigStructure[key].checkbox = true;
          this.projectConfigStructure[key].input =
            selectedMethods[key].persantage_of_wightage;
        }
      }
    }
    this.project.checkProject = savedProjectConfig.enable;
  },

  data() {
    return {
      project: {
        checkProject: false,
        projectScore: 20,
        projectBestScore: "",
      },
      projectMethods: [],
      projectConfigStructure: {},
    };
  },

  validations: {
    project: {
      projectScore: {
        required: requiredIf(function () {
          return this.project.checkProject;
        }),
      },
    },
    projectConfigStructure: {
      $each: {
        input: {
          required(value, parentVm) {
            return parentVm.checkbox;
          },
          numeric,
          customValidation() {
            // ✅ skip validation if not enabled or simple calculation
            if (
              !this.project ||
              this.project.checkProject === false ||
              this.activity_simple_calculation
            )
              return true;

            const checked = Object.values(this.projectConfigStructure).filter(
              (c) => c.checkbox
            );
            if (checked.length === 0) return true;

            const values = checked
              .map((c) => Number(c.input))
              .filter((v) => !isNaN(v));

            if (values.length === 0) return true;

            const allSame = values.every((v) => v === values[0]);
            const sumIs100 = values.reduce((a, b) => a + b, 0) === 100;

            return allSame || sumIs100;
          },
        },
      },
    },
  },

  methods: {
    async fetchProjectMethods() {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/projectmethods?course_id=${this.courseReport.course_id}`;
      try {
        const response = await axios.get(url);
        this.projectMethods = response.data;
        this.projectMethods.forEach((method) => {
          this.$set(this.projectConfigStructure, method.id, {
            checkbox: false,
            input: "",
          });
        });
      } catch (error) {
        this.$toast.error("Failed to fetch project methods", {
          position: "top",
          duration: 3000,
        });
      }
    },
  },
};
</script>

<style>
.project p {
  font-size: 16px;
  font-weight: 600;
}
.project p small {
  font-size: 10px;
  font-weight: 600;
}
.project span {
  font-size: 12px;
  font-weight: 600;
}
</style>
